<div class="homepage-greeting">
  <h1 *ngIf="user$ | async as user">{{
    'cartAdministration.miniLogin.userGreeting' | cxTranslate: { name: user.name | formatUsername }
    }}</h1>
</div>